import React from 'react';
import { connect } from 'react-redux';
import { updateData, updateFilterData, updateEditData, setUploadFromSubmit } from "../actions";
import ControlService from "../../helper/controlservice";
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import { toast } from 'react-toastify';
import Message from "../../helper/component/Message";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import { settings } from '../../config/settings';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { fetchUploadApi } from '../../helper/common/upload';
import Loading from '../../helper/component/Loading';
import { AzureImageAnalysis, GoogleImageAnalysis } from './_private';

require('dotenv').config();
// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateSize);
const _ = require('lodash');

const extension = (file) => {
    let ext = typeof file === 'string' ? (file.length > 0 ? file.split('.').pop() : '') : '';

    return ext.toLowerCase().trim();
}
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value)),
        setUploadFromSubmit: (data) => dispatch(setUploadFromSubmit(data))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    uploadparams: state.formDataReducer.uploadparams,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});
class UploadUI extends React.PureComponent {
    state = {
        touched: false,
        files: [],
        filelist: [],
        isApiCalling: false,
        duplicateError: null
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data[nextProps.formid] && nextProps.data[nextProps.formid][nextProps.control.key] !== prevState.filelist) {
            if (nextProps.data[nextProps.formid][nextProps.control.key] && Array.isArray(nextProps.data[nextProps.formid][nextProps.control.key])) {
                return { filelist: nextProps.data[nextProps.formid][nextProps.control.key] };
            } else if (nextProps.data[nextProps.formid][nextProps.control.key]) {
                var url = nextProps.data[nextProps.formid][nextProps.control.key]
                return { filelist: nextProps.control.defaultstorage ? [url] : [{ url }] }
            } else {
                return null;
            }
        }
        else return null;
    }
    componentDidMount() {
        this.controlVaildationCheck(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        var prevData = prevProps.data[prevProps.formid] ? prevProps.data[prevProps.formid][prevProps.control.key] : null
        var currData = this.props.data[this.props.formid] ? this.props.data[this.props.formid][this.props.control.key] : null
        if (prevData && prevData != currData) {
            this.controlVaildationCheck(this.props)
        }
        if (this.props.uploadparams) {
            this.props.setUploadFromSubmit(null);
            this.uploadMultipleFiles(this.props.uploadparams);
        }
    }
    controlVaildationCheck(props, value) {
        const { control, formid, data } = props;
        var _data = data[formid] ? data[formid][control.key] : null
        var validation = ControlService().validate(control, value ? value : _data);
        if (validation) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }
    }
    getFileName(file) {
        const { control, formid, data } = this.props;
        var _data = data[formid] ? data[formid] : {}
        if (!control.uploadtype || control.uploadtype == 'single') {
            if (_data[control.key + "_name"]) {
                return _data[control.key + "_name"];
            } else {
                if (this.props.control.defaultstorage) {
                    return typeof file === 'string' ? (file.length > 0 ? file.split('/').pop() : "File") : file.name;
                } else {
                    return file && file.length > 0 ? file.split('/').pop() : "File";
                }
            }
        } else {
            if (this.props.control.defaultstorage) {
                return typeof file === 'string' ? (file.length > 0 ? file.split('/').pop() : "File") : file.name;
            } else {
                return file && file.length > 0 ? file.split('/').pop() : "File";
            }
        }
    }
    validateFiles(control, fileItems) {
        let extValidationFailed = false;
        let fileSizeValidationFailed = false;
        if (Array.isArray(control.filetypevalidation) && control.filetypevalidation.length > 0) {
            fileItems.forEach(item => {
                let ext = extension(item.file.name);
                if (!control.filetypevalidation.find(x => x.trim().toLowerCase() === ext)) {
                    extValidationFailed = true;
                }
                if (item.fileSize > (control.filesize * 1048576)) {
                    fileSizeValidationFailed = true;
                }
            })
        }

        return { extValidationFailed, fileSizeValidationFailed }
    }
    onupdatefiles(fileItems) {
        debugger;
        const { control, formid } = this.props;
        var { extValidationFailed, fileSizeValidationFailed } = this.validateFiles(control, fileItems);
        if (extValidationFailed || fileSizeValidationFailed) {
            let fileExt = _.map(control.filetypevalidation).join(',');
            if (extValidationFailed) {
                this.setState({ filenotallowedError: control.filetypevalidationmsg ? control.filetypevalidationmsg : "Allowed " + fileExt })
            }
            // else {
            //     this.setState({ filenotallowedError: 'File size is greater than ' + control.filesize + '. Please upload file below ' + control.filesize + '.' })
            // }
            return;
        } else {
            this.setState({ filenotallowedError: "" })
        }
        if (!this.state.isApiCalling) {
            var file = [];
            var _fileItems = []
            if (!control.uploadtype || control.uploadtype == 'single') {
                if (fileItems.length == 0) {
                    this.setState({ filelist: [] });
                    this.props.update(control.key, null, formid);
                } else {
                    file.push(fileItems[0].file);
                    _fileItems.push(fileItems[0]);
                }
            } else {
                fileItems.map(fileItem => {
                    if (!this.state.files.find(x => x.name == fileItem.file.name)) {
                        file.push(fileItem.file);
                        _fileItems.push(fileItem);
                    } else if (!_fileItems.find(x => x.file.name == fileItem.file.name)) {
                        _fileItems.push(fileItem);
                    }
                })
            }

            this.setState({
                files: _fileItems.map(fileItem => fileItem.file),
                touched: true,
                duplicateError: null
            }, () => file.length > 0 && this.upload(file));
            if (file.length == 0 && fileItems.length > 0) {
                this.setState({ duplicateError: "File already uploaded!" })
            }
            // } 
        }
    }
    async upload(files) {
        this.CallResponseApi(files);
    }
    async CallResponseApi(files) {
        const { control, formid, token } = this.props;
        debugger;
        const data = this.props.data[formid] ? this.props.data[formid] : {};
        if (control.imageanalysisAI === 'google') {
            GoogleImageAnalysis(token, control, files, this.props, formid, data[control.googleAIfnname] ? data[control.googleAIfnname] : control.googleAIfnname);
        } else {
            var ENDPOINT = "";
            if (token && token.AzureFunctionEndpoint) {
                ENDPOINT = token.AzureFunctionEndpoint;
            } else {
                ENDPOINT = settings.REACT_APP_AZURE_FUNCTION_ENDPOINT;
            }
            var url = ENDPOINT + "/api/file";
            if (token.loginMethod) {
                control.apiurl = url;
            }

            if (control.responseapiurl || control.apiurl) {
                if (files.length > 0) {
                    this.setState({ isApiCalling: true })
                    let formData = new FormData();
                    var filename = [];
                    for (var i = 0; i < files.length; i++) {
                        formData.append(files[i].name, files[i]);
                        filename.push(files[i].name);
                    }
                    let apiUrl = control.responseapiurl ? control.responseapiurl : control.apiurl;
                    var param = {};
                    if (control.responseapiparam) {
                        control.responseapiparam.forEach(item => {
                            if (item.isdatamodel) {
                                param[item.key] = data[item.value];
                            } else {
                                param[item.key] = item.value;
                            }
                            var paramVal = ControlService().GetParamUrl(item.value)
                            if (param[item.key] == item.value && paramVal) {
                                param[item.key] = paramVal;
                            }
                        })
                    }
                    if (control.responseapiparam && control.responseapiparam.length > 0) {
                        var QueryStr = Object.keys(param)
                            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(param[k]))
                            .join('&');
                        apiUrl = "/" + apiUrl + '?' + QueryStr;
                    }

                    const headers = new Headers();
                    headers.append('Authorization', 'bearer ' + token.accesstoken);
                    headers.append("api-key", token.apikey);
                    if (control.Inputparamname) {
                        headers.append(control.Inputparamname, data[control.Inputparamvalue]);
                    }
                    var method = 'POST';
                    var uploadurl = "";
                    if (apiUrl.indexOf("http") >= 0) {

                        var dirname = token.user.ActiveApp ? token.user.ActiveApp.database + "files" : '';

                        if (control.storagefolder) {
                            dirname = control.storagefolder;
                        }
                        uploadurl = apiUrl + "?idx=" + dirname;
                    } else {
                        uploadurl = (token.baseapiurl ? token.baseapiurl : settings.BASE_API_URL) + apiUrl
                    }

                    fetchUploadApi(uploadurl, method, headers, formData)
                        .then(res => {

                            this.setState({ isApiCalling: false })
                            //console.log(res)
                            var datanode = res; //&& res ? JSON.parse(res) : {};
                            var resultdata = {};
                            if (datanode.data) {
                                resultdata = datanode.data;
                            } else {

                                resultdata = res;
                            }
                            if (!control.uploadtype || control.uploadtype == 'single') {
                                data[control.key] = resultdata;
                                this.props.update(control.key + "_name", filename.length > 0 ? filename[0] : '', formid);
                                this.props.update(control.key + "_url", resultdata, formid);

                                if (control.imageanalysisAI === 'azure') {
                                    AzureImageAnalysis(token, control, resultdata, this.props, formid);
                                }
                            } else {
                                if (Array.isArray(data[control.key])) {
                                    if (Array.isArray(resultdata)) {
                                        resultdata.forEach(item => {
                                            data[control.key].push(item);
                                        })
                                    } else {
                                        data[control.key].push(resultdata);
                                    }
                                } else {
                                    data[control.key] = [];
                                    if (Array.isArray(resultdata)) {
                                        resultdata.forEach(item => {
                                            data[control.key].push(item);
                                        })
                                    } else {
                                        data[control.key].push(resultdata);
                                    }
                                }
                                if (control.detailedoutput) {
                                    data[control.key].forEach((item, index) => {
                                        let arr = {};
                                        arr.name = filename[index];
                                        arr.url = item;
                                        if (Array.isArray(data[control.detailedoutputkey]))
                                            data[control.detailedoutputkey].push(arr);
                                        else {
                                            data[control.detailedoutputkey] = [];
                                            data[control.detailedoutputkey].push(arr);
                                        }
                                    });
                                }
                            }
                            this.controlVaildationCheck(this.props, data[control.key]);
                            this.props.update(control.key, data[control.key], formid);
                            // }
                        })
                        .catch(err => {
                            this.setState({ isApiCalling: false })
                            console.log(err);
                        });
                }
            }
        }
    }
    DeleteAttachedfile(file) {
        const { control, formid } = this.props;
        const data = this.props.data[this.props.formid];
        var idx = this.state.filelist.indexOf(file);
        let files = this.state.files;
        if (control.deleteapiurl) {
            var params = {}
            this.props.control.DeleteApiParam.forEach(item => {
                if (item.isdatamodel) {
                    params[item.key] = data[item.value];
                } else if (file[item.value]) {
                    params[item.key] = file[item.value];
                } else {
                    params[item.key] = item.value;
                }
            })
            if (!control.method) {
                control.method = "post";
            }
            // this._controlService.setPageVarible(this.props.control.DeleteApiParam, params, this.AuthService);
            ControlService().ServiceRequest(control.deleteapiurl, params, control, this.props.token, data)
                .then((res) => {
                    if (!control.uploadtype || control.uploadtype == 'single') {
                        data[control.key] = "";
                        if (data[control.key + "_name"]) {
                            data[control.key + "_name"] = "";
                        }
                        if (data[control.key + "_url"]) {
                            data[control.key + "_url"] = "";
                        }
                    } else {
                        data[control.key].splice(idx, 1);
                        if (control.detailedoutput && Array.isArray(data[control.detailedoutputkey]) && data[control.detailedoutputkey].length > 0) {
                            data[control.detailedoutputkey].splice(idx, 1);
                        }
                    }
                    this.setState({ filelist: data[control.key] });
                    this.props.update(control.key, data[control.key], formid);
                })
                .catch(err => {
                    console.log(err);
                });
        } else {
            if (!control.uploadtype || control.uploadtype == 'single') {
                data[control.key] = control.defaultstorage ? {} : "";
                if (data[control.key + "_name"]) {
                    data[control.key + "_name"] = "";
                }
                if (data[control.key + "_url"]) {
                    data[control.key + "_url"] = "";
                }
                files = [];
            } else {
                data[control.key].splice(idx, 1);
                files.splice(idx, 1);

                if (control.detailedoutput && Array.isArray(data[control.detailedoutputkey]) && data[control.detailedoutputkey].length > 0) {
                    data[control.detailedoutputkey].splice(idx, 1);
                }
            }
            this.setState({ filelist: data[control.key], files: files });
            this.props.update(control.key, data[control.key], formid);
        }
    }
    uploadMultipleFiles(submitparams = null) {
        const { control } = this.props;
        const data = this.props.data[this.props.formid];
        if (this.state.files.length > 0) {
            let formData = new FormData();

            for (var i = 0; i < this.state.files.length; i++) {
                formData.append(this.state.files[i].name, this.state.files[i]);
            }
            let apiUrl = control.apiurl;
            var param = {};
            control.ApiParam.forEach(item => {
                if (item.isdatamodel) {
                    param[item.key] = data[item.value];
                } else if (item.isuploadonsubmitparam && submitparams && submitparams.formParams[item.value]) {
                    param[item.key] = submitparams.formParams[item.value];
                } else {
                    param[item.key] = item.value;
                }
                var paramVal = ControlService().GetParamUrl(item.value)
                if (param[item.key] == item.value && paramVal) {
                    param[item.key] = paramVal;
                }
            })
            if (control.ApiParam && control.ApiParam.length > 0) {
                var QueryStr = Object.keys(param)
                    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(param[k]))
                    .join('&');
                apiUrl = "/" + apiUrl + '?' + QueryStr;
            }

            const headers = new Headers();
            headers.append('Authorization', 'bearer ' + this.props.token.accesstoken);
            // headers.append('Content-Type', 'multipart/form-data');
            var method = 'POST';
            if (control.method) {
                method = "post";
            }
            fetch((this.props.token.baseapiurl ? this.props.token.baseapiurl : settings.BASE_API_URL) + apiUrl, { method: method, headers: headers, body: formData })
                .then(response => {
                    if (response.status > 200) {
                        if (submitparams) {
                            toast.success(<Message message={submitparams.successmessage.text + " ,Upload document failed!"} icon={submitparams.successmessage.icon} title={submitparams.successmessage.title} type="success" />)
                        } else {
                            toast.error(<Message message={`Upload document failed!`} type="error" />)
                        }
                    } else {
                        if (submitparams) {
                            toast.success(<Message message={submitparams.successmessage.text} icon={submitparams.successmessage.icon} title={submitparams.successmessage.title} type="success" />)
                        }
                        var fileList = Array.isArray(data[control.key]) ? data[control.key] : [];
                        this.state.files.map(item => {
                            fileList.push({ attachmenturl: item.name });
                        })
                        this.setState({ filelist: fileList, isNew: true });
                        this.setState({ files: [] });
                    }
                });
        } else {
            if (submitparams) {
                toast.success(<Message message={submitparams.successmessage.text} icon={submitparams.successmessage.icon} title={submitparams.successmessage.title} type="success" />)
            }
        }
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid } = this.props;
        var data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);

        if (action == 'write') {
            return (
                <div className="file-upload mb-3">
                    <Loading token={this.props.token} enable={this.state.isApiCalling} />
                    {control.imageurl && <img src={control.imageurl} width="100" height="100" alt={column.label} className="mb-2 img-fluid" />}
                    {control.label &&
                        <label className="d-block">
                            {control.label}
                            {control.require && <sup className="text-danger font-weight-bold">*</sup>}
                            {control.showhelptext &&
                                <span className={"custom-tooltip"}>
                                    <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                    <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                </span>
                            }
                        </label>
                    }
                    <div className={(shouldMarkError ? " border-danger " : " ") + (control.isTraditional ? ' isdefultView ' : ' ')} >
                        <FilePond ref={ref => this.pond = ref}
                            labelIdle={'Browse'}
                            allowFileSizeValidation={true}
                            maxFileSize={control.filesize + 'MB'}
                            allowDrop={true}
                            files={this.state.files}
                            allowMultiple={!control.uploadtype || control.uploadtype == 'single' ? false : true}
                            maxFiles={!control.uploadtype || control.uploadtype == 'single' ? 1 : 5}
                            onupdatefiles={fileItems => this.onupdatefiles(fileItems)}
                            disabled={this.props.disabled}
                        >
                        </FilePond>
                    </div>
                    {Array.isArray(this.state.filelist) && this.state.filelist.length > 0 &&
                        <div className="row">
                            <div className="col-md-12 file-table">
                                Document(s)
                            </div>
                            <div className="col-md-12 file-table">
                                <ul>
                                    {this.state.filelist.map(file => {
                                        return (
                                            this.getFileName(file) ?
                                                <li>
                                                    <a href={file.url ? file.url : file} target="_blank">
                                                        {this.getFileName(file)}
                                                    </a>
                                                    {!file.isNew &&
                                                        <button aria-label="Delete" className="btn-no pointer p-1 icon-link pr-2" onClick={(e) => { e.preventDefault(); this.DeleteAttachedfile(file) }}>
                                                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                                                        </button>
                                                    }
                                                    {!file.isNew &&
                                                        (extension(file.url ? file.url : file) === 'doc' || extension(file.url ? file.url : file) === 'docx') ?
                                                        <button aria-label="View" className="btn-no pointer p-1 icon-link pr-2" onClick={(e) => { e.preventDefault(); window.open("https://view.officeapps.live.com/op/embed.aspx?src=" + (file.url ? file.url : file), '_blank') }}>
                                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                                        </button>
                                                        : (extension(file.url ? file.url : file) === 'pdf') ?
                                                            <button aria-label="View" className="btn-no pointer p-1 icon-link pr-2" onClick={(e) => { e.preventDefault(); window.open("http://docs.google.com/gview?url=" + (file.url ? file.url : file) + "&embedded=true", '_blank') }}>
                                                                <i className="fa fa-eye" aria-hidden="true"></i>
                                                            </button>
                                                            :
                                                            <OverlayTrigger trigger="click" placement="right" overlay={(
                                                                <Popover id="popover-basic">
                                                                    {/* <Popover.Title as="h3">Popover right</Popover.Title> */}
                                                                    <Popover.Content>
                                                                        <img src={file.url ? file.url : file} alt={file.name ? file.name : 'Image'} width="300" height="400" />
                                                                    </Popover.Content>
                                                                </Popover>
                                                            )}>
                                                                <button aria-label="View" onClick={(e) => { e.preventDefault(); }} className="btn-no pointer p-1 icon-link pr-2">
                                                                    <i className="fa fa-eye" aria-hidden="true"></i>
                                                                </button>
                                                            </OverlayTrigger>
                                                    }
                                                </li>
                                                : <div>{typeof file === 'string' ? file : ''}</div>
                                        )
                                    })
                                    }
                                </ul>
                            </div>

                        </div>
                    }
                    {(shouldMarkError && this.state.filelist.length == 0) &&
                        <small className="form-text text-danger">
                            {control.errormsg ? control.errormsg : 'You must select a ' + (control.label ? control.label : 'File') + '.'}
                        </small>
                    }
                    {this.state.duplicateError &&
                        <small className="form-text text-danger">
                            {this.state.duplicateError}
                        </small>
                    }
                    {this.state.filenotallowedError &&
                        <small className="form-text text-danger">
                            {this.state.filenotallowedError}
                        </small>
                    }
                    {control.description && <div className="form-text">{control.description}</div>}



                </div>
            );
        } else {
            return (
                <div style={{ marginHorizontal: 10, marginBottom: 10 }}>
                    <span style={{ fontSize: 13 }}>{control.label}</span>
                    <span style={{ paddingLeft: 30, fontWeight: 'bold' }}>
                        <image src={data[control.key]} />
                    </span>
                </div>
            );
        }
    }
}

export default connect(
    mapStateToProps, bindAction
)(UploadUI);